// extracted by mini-css-extract-plugin
export default {"container":"jdmXK","term":"qsE7u"};